import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmailTemplateDataService } from 'src/app/services/email-template-data.service';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-invite-only',
  templateUrl: './invite-only.component.html',
  styleUrls: ['./invite-only.component.scss']
})
export class InviteOnlyComponent implements OnInit {
  public activeTheme: any;
  public firstName: string;
  public lastName: string;
  public email: string;
  public confirmEmail: string;
  public message: string;

  constructor(
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
    private api: ZpDataService,
    private emailTemplateDataService: EmailTemplateDataService
  ) { }

  ngOnInit(): void {
    this.activeTheme = this.themeService.active;
  }

  saveForm() {
    if (this.validateForm()) {
      this.emailTemplateDataService.setData({
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        userList: [],
      });
      this.router.navigate(['/email-template']);
    } 
  }

  validateForm(): boolean {
    if (!this.firstName || !this.lastName || !this.email || !this.confirmEmail) {
      this.message = 'Please fill all the fields.'
      return false;
    }
    if (this.email !== this.confirmEmail) {
      this.message = 'Please confirm your email correctly.'
      return false;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.email)) {
      this.message = 'Please write your email in the right format.'
      return false;
    }
    return true; // Form is valid
  }

}
